export default __webpack_public_path__ + "static/media/WireTypes.ea44d0d1.jpg";